import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import OAWorkflowTaskList from "./OAWorkflowTaskList";
import PGSTaskList from "./PGSTaskList";
import PGSTaskDetail from "./PGSTaskDetail";
import PGSValidationResults from "./PGSValidationResults";
import PGSIntakeUpload from "./PGSIntakeUpload";
import { axios_tenant } from "../../../../axios";

/**
 * Top-level container for Post Grant Support Workflow.
 * Handles sub-routing under /collaboration-space/pgs-workflow.
 */
const PGSWorkflow = () => {
    const navigate = useNavigate();

    // Common 403 redirect logic
    useEffect(() => {
        const interceptorId = axios_tenant.interceptors.response.use(
            (response) => response,
            (error) => {
                if (
                    error?.response?.status === 403 &&
                    error?.config?.url?.includes("/collaboration/workflow") &&
                    !error?.config?.ignore403
                ) {
                    navigate("/dashboard", { replace: true });
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios_tenant.interceptors.response.eject(interceptorId);
        };
    }, [navigate]);

    return (
        <Routes>
            <Route index element={<Navigate to="tasks" replace />} />
            <Route path="tasks" element={<PGSTaskList />} />
            <Route path="tasks/:taskId" element={<PGSTaskDetail />} />
            <Route path="upload" element={<PGSIntakeUpload />} />
            <Route path="validation-results" element={<PGSValidationResults />} />
            <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
    );
};

export default PGSWorkflow;
